import React, { useEffect, useState } from 'react'
import CountryFlag from '../components/CountryFlag/CountryFlag';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCountryList } from '../redux/survey/survey.actions';
import { loginAction, getProfileDataAction } from '../redux/auth/auth.actions';
import { login } from '../firebase/googleLogin';
import { facebookLogin } from '../firebase/facebookLogin';
import { getTokenNotification } from '../firebase';
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { toast } from 'react-toastify';


export default function Login() {
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [phoneCode, setPhoneCode] = useState("+39");
    const [fcmToken, setFcmToken] = useState("");
    const [deviceId, setDeviceId] = useState("");
    const [currentLanguage, setCurrentLanguage] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loginData, isLoading } = useSelector((state) => state.authInfo);
    const [formData, setFormData] = useState({
        email: '',
        phone: '',
        password: ''
    });
    const location = useLocation();

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const validateMobile = (phone) => /^\d{10}$/.test(phone);

    const handleInputChange = (e, field) => {
        const value = e.target.value;

        setFormData((prev) => ({
            ...prev,
            [field]: value
        }));

        if (field === 'email' && value) {
            setFormData((prev) => ({ ...prev, phone: '' }));
        } else if (field === 'phone' && value) {
            setFormData((prev) => ({ ...prev, email: '' }));
        }
    };

    const handleShowPassword = () => {
        setIsShowPassword(!isShowPassword);
    };

    const getFcmTokenAndDeviceId = async () => {
        try {
            const fToken = await getTokenNotification();
            const deviceId = await getCurrentBrowserFingerPrint().then(fp => {
                return fp;
            });
            setFcmToken(fToken);
            setDeviceId(deviceId);
        } catch (error) {
            console.error("error", error);
        }
    };

    getFcmTokenAndDeviceId();

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.email && !validateEmail(formData.email)) {
            toast.error(currentLanguage === "Italian" ? 'Formato email non valido' : 'Invalid email format');
            return;
        }

        if (formData.phone && !validateMobile(formData.phone)) {
            toast.error(currentLanguage === "Italian" ? 'Numero di telefono non valido' : 'Invalid mobile number');
            return;
        }

        if (!formData.email && !formData.phone) {
            toast.error(currentLanguage === "Italian" ? 'Inserisci un\'email o un numero di telefono valido' : 'Enter a valid email or mobile number');
            return;
        }

        if (!formData.password) {
            toast.error(currentLanguage === "Italian" ? 'La password è obbligatoria' : 'Password is required');
            return;
        } else if (formData.password.length < 6) {
            toast.error(currentLanguage === "Italian" ? 'La password deve contenere almeno 6 caratteri' : 'Password must be at least 6 characters');
            return;
        }

        try {
            const data = {
                os: "web",
                fcmToken: fcmToken ? fcmToken : "",
                deviceId: deviceId?.toString(),
                login: formData?.email || formData?.phone,
                // referralId: "EUKRBYY3WH",//if user has then
            };
            dispatch(loginAction({ ...formData, ...data }))
        } catch (error) {
            console.log("error", error);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    useEffect(() => {
        setCurrentLanguage(localStorage.getItem("language"));
    }, []);


    const fromPage = location?.state?.from || "unknown";

    // console.log("profileData", profileData);
    useEffect(() => {
        dispatch(getCountryList());
        if (loginData?.status === 200 || loginData?.status === 201) {
            localStorage.setItem("Authorization", loginData?.token);
            // Check if user profile data is complete
            const profileData = loginData?.data;
            if (!profileData?.nation_country?.id && !profileData?.gender?.name && !profileData?.city?.id && !profileData?.region_state?.id && !profileData?.dob?.date && !profileData?.education?.name && !profileData?.civilState?.name) {
                toast.success(currentLanguage === "Italian" ? "Completa il tuo profilo per continuare." : "Please complete your profile to continue.");
                navigate("/complete-profile");
            } else {
                // Check for stored redirect path first, then location state, then default to home
                const storedRedirectPath = localStorage.getItem('redirectAfterLogin');
                if (storedRedirectPath) {
                    localStorage.removeItem('redirectAfterLogin'); // Clear the stored path
                    navigate(storedRedirectPath);
                } else if (fromPage && fromPage !== "unknown") {
                    navigate(fromPage);
                } else {
                    navigate("/");
                }
            }
        }
    }, [dispatch, loginData, navigate])

    return (
        <div className="login_wrapper">
            <div className='login'>
                <div className="top_text">
                    {currentLanguage === "Italian"
                        ? "Inserisci il tuo numero di cellulare registrato o l'email per accedere"
                        : "Enter your registered mobile number or email id to log in"
                    }
                </div>

                <div className="input_wrapper">
                    <input
                        type="text"
                        placeholder={currentLanguage === "Italian" ? "Email" : "Email Id"}
                        value={formData.email}
                        onChange={(e) => handleInputChange(e, 'email')}
                        onKeyDown={handleKeyDown}
                    />
                </div>

                <div className="or">{currentLanguage === "Italian" ? "Oppure" : "Or"}</div>

                <div className="input_wrapper mobile">
                    <CountryFlag setPhoneCode={setPhoneCode} />
                    <input
                        type="text"
                        name="phone"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={10}
                        placeholder={currentLanguage === "Italian" ? "Inserisci il numero di cellulare" : "Enter mobile number"}
                        value={formData.phone}
                        onChange={(e) => handleInputChange(e, 'phone')}
                        onKeyDown={handleKeyDown}
                    />
                </div>

                <div className="input_wrapper passowrd mb10">
                    <input
                        type={isShowPassword ? 'text' : 'password'}
                        placeholder={currentLanguage === "Italian" ? 'Password *' : 'Password *'}
                        value={formData.password}
                        onChange={(e) => handleInputChange(e, 'password')}
                        onKeyDown={handleKeyDown}
                    />
                    <div className="pass_button" onClick={handleShowPassword}>
                        <img src={`${process.env.PUBLIC_URL}/images/${isShowPassword ? 'password_show' : 'password_hide'}.png`} alt="" />
                    </div>
                </div>

                <Link to="/auth/forget-password" className="forget_pass">
                    {currentLanguage === "Italian" ? "Password dimenticata?" : "Forgot Password?"}
                </Link>

                <div className="action mb15">
                    <button onClick={handleSubmit} disabled={isLoading}>
                        {isLoading
                            ? (currentLanguage === "Italian" ? 'Caricamento...' : 'Loading...')
                            : (currentLanguage === "Italian" ? 'Accedi' : 'Login')
                        }
                    </button>
                </div>

                <div className="or">{currentLanguage === "Italian" ? "Oppure" : "Or"}</div>

                <div className="login_option">
                    <button style={{ cursor: "pointer" }} onClick={e => login(dispatch, navigate)}>
                        <img src={`${process.env.PUBLIC_URL}/images/google.svg`} alt="" />
                    </button>
                    <button style={{ cursor: "pointer" }} onClick={e => facebookLogin(dispatch, navigate)}>
                        <img src={`${process.env.PUBLIC_URL}/images/facebook.svg`} alt="" />
                    </button>
                    {/* <button style={{ cursor: "pointer" }} onClick={e => AppleLoginCom(Apple, navigate)}>
                        <img src={`${process.env.PUBLIC_URL}/images/apple.svg`} alt="" />
                    </button> */}
                </div>

                <div className="have_account">
                    {currentLanguage === "Italian"
                        ? "Non hai un account? "
                        : "Don't you have an account? "
                    }
                    <Link to="/auth/signup">{currentLanguage === "Italian" ? "Registrati" : "Sign up"}</Link>
                </div>
            </div>

            <div className="agree">
                {currentLanguage === "Italian"
                    ? "Continuando, accetti i nostri "
                    : "By continuing, you are agreeing to our "
                }
                <a href={`https://votiamo.com/terms/${currentLanguage === "Italian" ? "it" : ""}`} target='_blank'>
                    {currentLanguage === "Italian" ? "termini e condizioni" : "terms & conditions"}
                </a>
                {" "} & {" "}
                <a href={`https://votiamo.com/privacy/${currentLanguage === "Italian" ? "it" : ""}`} target='_blank'>
                    {currentLanguage === "Italian" ? "politica sulla privacy" : "privacy policy"}
                </a>
            </div>
        </div>
    );
}